import React from 'react';
import { PlatformAdministration } from '../../components/platform/PlatformAdministration';

export const SystemSettings: React.FC = () => <PlatformAdministration />;
